import { PageRequest } from '../../../api/api.types';
import { Dispatch } from 'react';
import { AdminApi } from '../../../api/api.apiclient';
import { DELETE_BROKER, GET_BROKER, GET_BROKER_LIST, POST_BROKER, PUT_BROKER } from '../types/broker.types';
import { BrokerModel, EditBrokerRequest } from '../../../api/admin/admin.types';

export const getBrokerList = (pageRequest?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.brokers.listAllBrokers(pageRequest);

  dispatch({
    type: GET_BROKER_LIST,
    payload: {
      page: response.data
    }
  });
};

export const getBroker = (id: number) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await AdminApi.brokers.getOneBroker(id);

    dispatch({
      type: GET_BROKER,
      payload: {
        selectedBroker: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_BROKER,
      payload: {
        selectedBroker: null
      }
    });
  }
};

export const addNewBroker = (request: EditBrokerRequest) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.brokers.addBroker(request);

  dispatch({
    type: POST_BROKER,
    payload: {
      success: true,
      newBroker: response.data
    }
  });
};

export const deleteBroker = (id: number) => async (dispatch: Dispatch<any>) => {
  await AdminApi.brokers.deleteBroker(id);
  dispatch({
    type: DELETE_BROKER,
    payload: {
      success: true
    }
  });
};

export const editBroker = (id: number, request: EditBrokerRequest) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.brokers.editBroker(id, request);

  dispatch({
    type: PUT_BROKER,
    payload: {
      selectedBroker: response.data
    }
  });
};